import script from "./TabPreReportGlobal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabPreReportGlobal.vue?vue&type=script&setup=true&lang=ts"

import "./TabPreReportGlobal.vue?vue&type=style&index=0&id=8ede7b56&scoped=true&lang=scss"

import exportComponent from "/Users/thibertletullier/Workspace/Declic/comex/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ede7b56"]])

export default __exports__